import { render, staticRenderFns } from "./LivesLive.vue?vue&type=template&id=661a3bdc"
import script from "./LivesLive.vue?vue&type=script&lang=js"
export * from "./LivesLive.vue?vue&type=script&lang=js"
import style0 from "./LivesLive.vue?vue&type=style&index=0&id=661a3bdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports